export default "__VITE_ASSET__BAu1bjH6__"